var React = require('react');

function FooterClockIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h402.014v336.33H0z","key":0}),React.createElement("path",{"d":"M167.75 316.12c83 0 151.29-68.292 151.29-151.474 0-83-68.29-151.293-151.472-151.293-83.004 0-151.293 68.293-151.293 151.293 0 83.182 68.29 151.475 151.475 151.475zm-66.113-128.77c-8.354 0-14.71-6.356-14.71-14.714 0-8.172 6.356-14.53 14.71-14.53h51.22V86.002c0-8.354 6.539-14.71 14.71-14.71 8.355 0 14.712 6.356 14.712 14.71v86.635c0 8.358-6.357 14.714-14.711 14.714h-65.93z","fill":"#fff","fillRule":"nonzero","key":1})]);
}

FooterClockIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 403 337","fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"};

module.exports = FooterClockIcon;

FooterClockIcon.default = FooterClockIcon;
